import { render, staticRenderFns } from "./ReportsGrid.vue?vue&type=template&id=06942d61"
import script from "./ReportsGrid.vue?vue&type=script&lang=js"
export * from "./ReportsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports